export class SendOtpResponseBody {
    loginId: string;
    otpStatus: string;
    smsStatus: string;
    mobileNo: string;
    otp: string;
}
